import FloatingCompoundTable from "@/components/FloatingCompoundTable.vue";
import { EVENTS, TREND_DIRECTION_TYPE, KPI_DIRECTION_TYPE, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, COLORS, ANALYTICS_CSV_PAGE_SIZE, CPC_DECILE_COLORS, CVR_HEATMAP_COLORS, PROFIT_DECILE_COLORS, PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS, FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS } from "@/utils/constants";
import { generateColorBasedOnState, getColorForDecile, getColorsBasedOnRange, getDescriptionBasedOnKpiKey, getCampaignsStateColor, getProfitPercentageDecileColor, transformGoogleSheetFromAsyncCSV } from "@/utils/transformers";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import PerformanceProductTableGroupBy from "@/components/dashboard_v2/PerformanceProductTableGroupBy.vue";
import { mapState, mapGetters } from "vuex";
import { REVENUE_EXCL_VAT_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, PPC_SALES_FIELD, TACOS_FIELD, RATING_FIELD, BUYBOX_FIELD, RATING_TOTAL_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, PAGE_VIEWS_FIELD, RETURN_RATE_FIELD, MARKETPLACE_FIELD, PRODUCT_FIELD, SELLER_FIELD, BAR_ROAS_FIELD, CLICKS_FIELD, CPC_FIELD, CVR_FIELD, SPEND_FIELD, SPONSORED_ASIN_FIELD, SPONSORED_SALES_FIELD, UNITS_SOLD_FIELD, AVERAGE_UNIT_PRICE_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PRODUCT_SEGMENT_FIELD, BIG_AVG_BSR_FIELD, PRODUCT_BRAND_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD, ORGANIC_SALES_FIELD } from "@/utils/table_fields";
import FlexRow from "@/components/FlexRow.vue";
import { NumberValue, BoxedValue, BarWithValue, PercentageValue, RatingValue, DottedValue, OverlapBarValue, RateChangeValue, CurrencyValue, ValueElement, HugValue, MarketplaceValue, ProductValue, ParentProductValue, SignedBarWithValue, ProductSegmentValue, BsrValueWithGraph, BrandParentValue } from "@/components/tableElements";
import WrapWithArrow from "@/components/tableElements/WrapWithArrow.vue";
import PerformanceProductTableTotal from "@/components/dashboard_v2/PerformanceProductTableTotal.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import AppIconGroup from "@/components/AppIconGroup";
import AppIcon from "@/components/AppIcon.vue";
import FilterDivider from "@/components/new-filters/FilterDivider.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import { capitalize } from "vue";
import { processDate } from "@/utils";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import BlockBarWithValue from "@/components/tableElements/BlockBarWithValue.vue";
import BoxAndBarWithValue from "@/components/tableElements/BoxAndBarWithValue.vue";
import BlockStyledBar from "@/components/tableElements/BlockStyledBar.vue";
import WrapWithAlertIcon from "@/components/WrapWithAlertIcon.vue";
import ViewExportDropdown from "@/components/ViewExportDropdown.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { HISTORY_PERIOD_TEXTS } from "../../utils/datepicker";
import { getProductType, PRODUCT_TYPES } from "@/utils/product_type_utils";
import EmptySegments from "@/components/EmptySegments.vue";
import VariableStyledBar from "@/components/tableElements/VariableStyledBar.vue";
import LayerBars from "@/components/tableElements/LayerBars.vue";
import BarSlotWithValue from "@/components/tableElements/BarSlotWithValue.vue";
import EvolutionTypeSwitcher from "@/components/EvolutionTypeSwitcher.vue";
import { country_codes_with_flags_and_marketplace_ids } from "@/utils/countries";
export default {
  name: "PerformanceProductTable",
  components: {
    FloatingCompoundTable,
    WrapWithPopover,
    PerformanceProductTableGroupBy,
    FlexRow,
    NumberValue,
    BoxedValue,
    RatingValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    WrapWithArrow,
    RateChangeValue,
    CurrencyValue,
    ValueElement,
    HugValue,
    PerformanceProductTableTotal,
    MarketplaceValue,
    ProductValue,
    AppIconGroup,
    AppIcon,
    FilterDivider,
    ParentProductValue,
    SlotWithEvolutionValue,
    EvolutionValue,
    BlockStyledBar,
    BlockBarWithValue,
    BoxAndBarWithValue,
    SignedBarWithValue,
    WrapWithAlertIcon,
    ProductSegmentValue,
    ViewExportDropdown,
    BsrValueWithGraph,
    BrandParentValue,
    EmptySegments,
    VariableStyledBar,
    LayerBars,
    BarSlotWithValue,
    EvolutionTypeSwitcher
  },
  emits: ["refresh", "changeDate", "refreshOtherKpis", "restoreEvolutionTable"],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  data() {
    return {
      EVENTS,
      TREND_DIRECTION_TYPE,
      KPI_DIRECTION_TYPE,
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      RATING_TOTAL_FIELD,
      COLORS,
      CPC_DECILE_COLORS,
      CVR_HEATMAP_COLORS,
      CVR_FIELD,
      PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS,
      HISTORY_PERIOD_TEXTS,
      standardized_parents: {},
      PRODUCT_TYPES,
      GROUP_BY_TAB_ELEMENTS,
      evolCategory: {
        prev_period: "",
        same_period_ly: "last_year_"
      },
      evolCategoryVendor: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_last_year"
      },
      sheetGenerationTaskIdentifiers: {
        [GROUP_BY_TAB_ELEMENTS.SELLER.key]: "",
        [GROUP_BY_TAB_ELEMENTS.MARKETPLACE.key]: "",
        [GROUP_BY_TAB_ELEMENTS.PRODUCT_PARENT.key]: "",
        [GROUP_BY_TAB_ELEMENTS.PRODUCT_ASIN.key]: "",
        [GROUP_BY_TAB_ELEMENTS.PRODUCT_SKU.key]: "",
        [GROUP_BY_TAB_ELEMENTS.SEGMENT.key]: ""
      },
      fieldsSources: {
        performance: {
          seller: [SELLER_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          marketplace: [MARKETPLACE_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          parent_asin: [PRODUCT_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          asin: [PRODUCT_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          product: [PRODUCT_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          segment: [PRODUCT_SEGMENT_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
          brand: [PRODUCT_BRAND_FIELD, REVENUE_EXCL_VAT_FIELD, REVENUE_SHARE_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, PAGE_VIEWS_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD]
        },
        listing: {
          seller: [SELLER_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          marketplace: [MARKETPLACE_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          parent_asin: [PRODUCT_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, BIG_AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          asin: [PRODUCT_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, BIG_AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          product: [PRODUCT_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, BIG_AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          segment: [PRODUCT_SEGMENT_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, BIG_AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD],
          brand: [PRODUCT_BRAND_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ASIN_SOLD_FIELD, ORGANIC_CVR_FIELD, ORGANIC_SALES_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, BIG_AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD]
        },
        advertising: {
          seller: [SELLER_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          marketplace: [MARKETPLACE_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          parent_asin: [PRODUCT_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          asin: [PRODUCT_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          product: [PRODUCT_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          segment: [PRODUCT_SEGMENT_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
          brand: [PRODUCT_BRAND_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD]
        },
        profit: {
          seller: [SELLER_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          marketplace: [MARKETPLACE_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          parent_asin: [PRODUCT_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          asin: [PRODUCT_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          product: [PRODUCT_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          segment: [PRODUCT_SEGMENT_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD],
          brand: [PRODUCT_BRAND_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD]
        },
        vendor: {
          seller: [SELLER_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          marketplace: [MARKETPLACE_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          parent_asin: [PRODUCT_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          asin: [PRODUCT_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          product: [PRODUCT_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          segment: [PRODUCT_SEGMENT_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD],
          brand: [PRODUCT_BRAND_FIELD, ORDERED_REVENUE_FIELD, SHIPPED_REVENUE_FIELD, SHIPPED_COGS_FIELD, CUSTOMER_RETURNS_FIELD, NET_PPM_FIELD, NET_PPM_PERCENTAGE_FIELD, NET_RECEIVED_UNITS_FIELD]
        }
      },
      CLICK_TO_FILTER_OPTIONS: {
        seller: this.sellersClickToFilter,
        marketplace: this.marketplacesClickToFilter,
        parent_asin: this.productChildAsinClickToFilter,
        product: this.productsClickToFilter,
        asin: this.asinsClickToFilter,
        segment: this.segmentClickToFilter,
        brand: this.productChildAsinClickToFilter
      },
      CLICK_TO_CLEAR_FILTER_OPTIONS: {
        seller: this.sellersClickToClearFilter,
        marketplace: this.marketplacesClickToClearFilter,
        parent_asin: this.productChildAsinClickToClear,
        product: this.productsClickToClearFilter,
        asin: this.asinsClickToClearFilter,
        segment: this.segmentClickToClear,
        brand: this.productChildAsinClickToClear
      },
      PARENT_TOGGLE_TYPES: {
        [GROUP_BY_TAB_ELEMENTS.PRODUCT_PARENT.key]: this.handleParentAsinToggle,
        [GROUP_BY_TAB_ELEMENTS.SEGMENT.key]: this.handleProductSegmentToggle,
        [GROUP_BY_TAB_ELEMENTS.BRAND.key]: this.handleBrandToggle
      }
    };
  },
  computed: {
    ...mapState({
      groupBy: state => state.dashboard_v2.product_table.group_by_text,
      productTable: state => state.dashboard_v2.product_table,
      currentTabValue: state => state.dashboard_v2.currentTabValue,
      periodCategory: state => state.dashboard_v2.periodCategory,
      currencyConfig: state => state.dashboard_v2.currencyConfig,
      sellers_filter: state => state.dashboard_v2.sellers_filter,
      marketplaces_filter: state => state.dashboard_v2.marketplaces_filter,
      products: state => state.dashboard_v2.products,
      segments: state => state.dashboard_v2.segments,
      product_segment_parents: state => state.dashboard_v2.product_table.product_segment_parents,
      period: state => state.dashboard_v2.period,
      product_brand_parents: state => state.dashboard_v2.product_table.product_brand_parents,
      brands_filter: state => state.dashboard_v2.brands
    }),
    ...mapGetters(["dashboardV2SingleMarketplace", "getCountryFlag"]),
    filteredItems() {
      const rows = this.productTable[this.currentTabValue].data[this.groupBy]?.items;
      if (this.groupBy === "parent_asin") {
        // Precompute active rows using Set for O(1) lookup
        const activeRows = new Set(Object.keys(this.standardized_parents).filter(key => this.standardized_parents[key]));
        return rows.filter(item => {
          // Check if the element is a parent (with children), a child of an active parent, or a parent without children
          return item.child_asin?.length > 0 ||
          // Parent with children
          item.is_child_asin && activeRows.has(item.standardized_parent_asin) ||
          // Child of an active parent
          item.standardized_parent_asin === null; // Parent without children
        });
      }
      if (this.groupBy === "segment") {
        const filteredRows = rows.filter(item => {
          // Check if the element is a parent (with children), a child of an active parent, or a parent without children
          return item.child_asin?.length > 0 ||
          // Parent with children
          item.is_child_asin && this.product_segment_parents.get(item?.product_segment).collapsed ||
          // Child of an active parent
          item.is_unassigned; // Parent without children
        });
        filteredRows.forEach(item => {
          item.child_asin?.forEach(child => {
            child.main_image_links_by_channel?.forEach(img => {
              img.redirect_link = `https://${img.amazon_link}`;
              img.flag = this.getCountryFlagFromSalesChannel(img.sales_channel);
            });
          });
        });
        return filteredRows;
      }
      return rows;
    },
    total() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.total;
    },
    minMax() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.minMax;
    },
    sort() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.sort;
    },
    revenueEvolutionSortKeys() {
      return {
        prev_period: {
          percentage: "revenue_excl_VAT_evol",
          currency: "revenue_excl_VAT_evol_currency"
        },
        same_period_ly: {
          percentage: "last_year_revenue_excl_VAT_evol",
          currency: "last_year_revenue_excl_VAT_evol_currency"
        }
      };
    },
    evolutionSortState() {
      // Match any evolution variant so the sort persists across period/type switches
      const k = this.revenueEvolutionSortKeys;
      return this.sort[k.prev_period.percentage] || this.sort[k.prev_period.currency] || this.sort[k.same_period_ly.percentage] || this.sort[k.same_period_ly.currency];
    },
    revenueColumnSortState() {
      return this.sort["revenue_excl_VAT"] || this.evolutionSortState;
    },
    maxCharCount() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.maxCharCount;
    },
    fields() {
      return this.fieldsSources[this.currentTabValue][this.groupBy];
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    },
    page: {
      set(val) {
        this.$store.dispatch("dashboardV2SetProductTablePage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.dashboardV2GetProductTablePage();
      }
    },
    perPage: {
      set(val) {
        this.$store.dispatch("dashboardV2SetProductTablePerPage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.dashboardV2GetProductTablePerPage();
      }
    },
    totalPages: {
      set(val) {
        this.$store.dispatch("dashboardV2SetProductTableTotalPages", val);
      },
      get() {
        return this.$store.getters.dashboardV2GetProductTableTotalPages();
      }
    },
    groupByFetcher() {
      return this.productTable[this.currentTabValue].data[this.groupBy].fetch;
    },
    csvFileName() {
      const dateRange = `${processDate(this.datePickerDate?.range.start, "DDMMM")}-${processDate(this.datePickerDate?.range.end, "DDMMMYYYY")}`;
      return `Dashboard_${capitalize(this.currentTabValue)}_${capitalize(this.groupBy)}_${dateRange}.csv`;
    },
    getTbodyTrClass() {
      if (this.groupBy === "parent_asin") {
        return item => `item-row 
                                ${item?.standardized_parent_asin || ""} 
                                ${item?.is_child_asin ? `is-child ${this.handleRowClass(item, this.filteredItems)}` : ""}
                                ${item?.standardized_parent_asin === null ? this.handleRowClass(item, this.filteredItems) : ""} 
                                ${item?.is_child_asin && item.last_child ? `last-child ` : ""} 
                                ${this.standardized_parents[item?.standardized_parent_asin] ? "visible" : "hidden"}
                            `;
      }
      if (this.groupBy === "segment") {
        return item => {
          const collapsed = this.product_segment_parents.get(item?.product_segment).collapsed;
          const last_item = item?.is_child_asin && item.last_child ? `last-child ${this.handleRowClass(item, this.filteredItems)}` : "";
          const is_child = item?.is_child_asin ? `is-child ${this.handleRowClass(item, this.filteredItems)}` : "";
          const segment = item?.product_segment || "";
          return `item-row ${collapsed ? "visible" : "hidden"} ${last_item} ${is_child} ${segment}`;
        };
      }
      if (this.groupBy === "brand") {
        return item => {
          const parent = this.product_brand_parents.get(item?.brand);
          if (parent) {
            const collapsed = parent.collapsed;
            const last_item = item?.is_child_asin && item.last_child ? `last-child ${this.handleRowClass(item, this.filteredItems)}` : "";
            const is_child = item?.is_child_asin ? `is-child ${this.handleRowClass(item, this.filteredItems)}` : "";
            const brand = item?.brand || "";
            return `item-row ${collapsed ? "visible" : "hidden"} ${last_item} ${is_child} ${brand}`;
          }
          return null;
        };
      }
      return item => this.handleRowClass(item, this.filteredItems);
    },
    getThClass() {
      return field => {
        if (field && field.key === "avg_bsr") {
          return [{
            ["not-allowed"]: !this.dashboardV2SingleMarketplace()
          }];
        }
        return [];
      };
    },
    csvSources() {
      return {
        performance: {
          seller: {
            [SELLER_FIELD.label]: SELLER_FIELD.key,
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          marketplace: {
            [MARKETPLACE_FIELD.label]: MARKETPLACE_FIELD.key,
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          parent_asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Asin: "asin",
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          product: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Sku: "sku",
            Asin: "asin",
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          segment: {
            Segment: PRODUCT_SEGMENT_FIELD.key,
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          },
          brand: {
            Brand: PRODUCT_BRAND_FIELD.key,
            [REVENUE_EXCL_VAT_FIELD.label]: REVENUE_EXCL_VAT_FIELD.key,
            ...this.getEvolutionsForField(REVENUE_EXCL_VAT_FIELD, {
              hasCurrencyEvolution: true
            }),
            [REVENUE_SHARE_FIELD.label]: REVENUE_SHARE_FIELD.key,
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [DAYS_INVENTORY_FIELD.label]: DAYS_INVENTORY_FIELD.key,
            [LOST_REVENUE_EXCL_VAT_FIELD.label]: LOST_REVENUE_EXCL_VAT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key,
            [PPC_SALES_FIELD.label]: PPC_SALES_FIELD.key,
            [TACOS_FIELD.label]: TACOS_FIELD.key
          }
        },
        listing: {
          seller: {
            [SELLER_FIELD.label]: SELLER_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          marketplace: {
            [MARKETPLACE_FIELD.label]: MARKETPLACE_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          parent_asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...(this.dashboardV2SingleMarketplace() ? {
              category_name: "category_name",
              category_link: "category_link",
              [BIG_AVG_BSR_FIELD.label]: BIG_AVG_BSR_FIELD.key,
              ...this.getEvolutionsForField(BIG_AVG_BSR_FIELD)
            } : {}),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Asin: "asin",
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...(this.dashboardV2SingleMarketplace() ? {
              category_name: "category_name",
              category_link: "category_link",
              [BIG_AVG_BSR_FIELD.label]: BIG_AVG_BSR_FIELD.key,
              ...this.getEvolutionsForField(BIG_AVG_BSR_FIELD)
            } : {}),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          product: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Sku: "sku",
            Asin: "asin",
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...(this.dashboardV2SingleMarketplace() ? {
              category_name: "category_name",
              category_link: "category_link",
              [BIG_AVG_BSR_FIELD.label]: BIG_AVG_BSR_FIELD.key,
              ...this.getEvolutionsForField(BIG_AVG_BSR_FIELD)
            } : {}),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          segment: {
            Segment: PRODUCT_SEGMENT_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...(this.dashboardV2SingleMarketplace() ? {
              category_name: "category_name",
              category_link: "category_link",
              [BIG_AVG_BSR_FIELD.label]: BIG_AVG_BSR_FIELD.key,
              ...this.getEvolutionsForField(BIG_AVG_BSR_FIELD)
            } : {}),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          },
          brand: {
            brand: PRODUCT_BRAND_FIELD.key,
            [PAGE_VIEWS_FIELD.label]: PAGE_VIEWS_FIELD.key,
            ...this.getEvolutionsForField(PAGE_VIEWS_FIELD),
            [TOTAL_QUANTITY_FIELD.label]: TOTAL_QUANTITY_FIELD.key,
            ...this.getEvolutionsForField(TOTAL_QUANTITY_FIELD),
            [ASIN_SOLD_FIELD.label]: ASIN_SOLD_FIELD.key,
            [ORGANIC_CVR_FIELD.label]: ORGANIC_CVR_FIELD.key,
            [ORGANIC_SALES_FIELD.label]: ORGANIC_SALES_FIELD.key,
            ...this.getEvolutionsForField(ORGANIC_SALES_FIELD),
            [RATING_FIELD.label]: RATING_FIELD.key,
            [RATING_TOTAL_FIELD.label]: RATING_TOTAL_FIELD.key,
            [AVERAGE_UNIT_PRICE_FIELD.label]: AVERAGE_UNIT_PRICE_FIELD.key,
            ...this.getEvolutionsForField(AVERAGE_UNIT_PRICE_FIELD),
            ...(this.dashboardV2SingleMarketplace() ? {
              category_name: "category_name",
              category_link: "category_link",
              [BIG_AVG_BSR_FIELD.label]: BIG_AVG_BSR_FIELD.key,
              ...this.getEvolutionsForField(BIG_AVG_BSR_FIELD)
            } : {}),
            [RETURN_RATE_FIELD.label]: RETURN_RATE_FIELD.key,
            [BUYBOX_FIELD.label]: BUYBOX_FIELD.key
          }
        },
        advertising: {
          seller: {
            [SELLER_FIELD.label]: SELLER_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            ...this.getEvolutionsForField(UNITS_SOLD_FIELD),
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          marketplace: {
            [MARKETPLACE_FIELD.label]: MARKETPLACE_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            ...this.getEvolutionsForField(UNITS_SOLD_FIELD),
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          parent_asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            ...this.getEvolutionsForField(UNITS_SOLD_FIELD),
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Asin: "asin",
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            ...this.getEvolutionsForField(UNITS_SOLD_FIELD),
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          product: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            ...this.getEvolutionsForField(UNITS_SOLD_FIELD),
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          segment: {
            Segment: PRODUCT_SEGMENT_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          },
          brand: {
            Brand: PRODUCT_BRAND_FIELD.key,
            [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
            ...this.getEvolutionsForField(SPONSORED_SALES_FIELD),
            [SPEND_FIELD.label]: SPEND_FIELD.key,
            ...this.getEvolutionsForField(SPEND_FIELD),
            [TACOS_FIELD.label]: TACOS_FIELD.key,
            [CLICKS_FIELD.label]: CLICKS_FIELD.key,
            [CPC_FIELD.label]: CPC_FIELD.key,
            [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
            [CVR_FIELD.label]: CVR_FIELD.key,
            [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key,
            "Sponsored Asin": SPONSORED_ASIN_FIELD.key
          }
        },
        profit: {
          seller: {
            [SELLER_FIELD.label]: SELLER_FIELD.key,
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          marketplace: {
            [MARKETPLACE_FIELD.label]: MARKETPLACE_FIELD.key,
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          parent_asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Asin: "asin",
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          product: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            Sku: "sku",
            Asin: "asin",
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          segment: {
            Segment: PRODUCT_SEGMENT_FIELD.key,
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          },
          brand: {
            Brand: PRODUCT_BRAND_FIELD.key,
            [PROFIT_REVENUE_FIELD.label]: PROFIT_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_REVENUE_FIELD),
            [PROFIT_CONTRIBUTIVE_MARGIN_FIELD.label]: PROFIT_CONTRIBUTIVE_MARGIN_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_CONTRIBUTIVE_MARGIN_FIELD),
            [PROFIT_PERCENTAGE_OF_REVENUE_FIELD.label]: PROFIT_PERCENTAGE_OF_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(PROFIT_PERCENTAGE_OF_REVENUE_FIELD),
            [PROFIT_COMMISSION_FIELD.label]: PROFIT_COMMISSION_FIELD.key,
            [PROFIT_FBA_DIRECT_FIELD.label]: PROFIT_FBA_DIRECT_FIELD.key,
            [PROFIT_FBA_INDIRECT_FIELD.label]: PROFIT_FBA_INDIRECT_FIELD.key,
            [PROFIT_REFUND_FIELD.label]: PROFIT_REFUND_FIELD.key,
            [PROFIT_COOP_FIELD.label]: PROFIT_COOP_FIELD.key,
            [PROFIT_COGS_FIELD.label]: PROFIT_COGS_FIELD.key,
            [PROFIT_OTHER_COSTS_FIELD.label]: PROFIT_OTHER_COSTS_FIELD.key,
            ["% of Advertising costs"]: "pl_advertising_costs_pc",
            [PROFIT_ADVERTISING_COSTS_FIELD.label]: PROFIT_ADVERTISING_COSTS_FIELD.key
          }
        },
        vendor: {
          seller: {
            [SELLER_FIELD.label]: SELLER_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          marketplace: {
            [MARKETPLACE_FIELD.label]: MARKETPLACE_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          parent_asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          asin: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          product: {
            [PRODUCT_FIELD.label]: PRODUCT_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          segment: {
            Segment: PRODUCT_SEGMENT_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          },
          brand: {
            Brand: PRODUCT_BRAND_FIELD.key,
            [ORDERED_REVENUE_FIELD.label]: ORDERED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(ORDERED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_REVENUE_FIELD.label]: SHIPPED_REVENUE_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_REVENUE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [SHIPPED_COGS_FIELD.label]: SHIPPED_COGS_FIELD.key,
            ...this.getEvolutionsForField(SHIPPED_COGS_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [CUSTOMER_RETURNS_FIELD.label]: CUSTOMER_RETURNS_FIELD.key,
            [NET_PPM_FIELD.label]: NET_PPM_FIELD.key,
            [NET_PPM_PERCENTAGE_FIELD.label]: NET_PPM_PERCENTAGE_FIELD.key,
            ...this.getEvolutionsForField(NET_PPM_PERCENTAGE_FIELD, {
              suffixes: this.evolCategoryVendor
            }),
            [NET_RECEIVED_UNITS_FIELD.label]: NET_RECEIVED_UNITS_FIELD.key,
            ...this.getEvolutionsForField(NET_RECEIVED_UNITS_FIELD, {
              suffixes: this.evolCategoryVendor
            })
          }
        }
      };
    },
    groupByAggregatedView() {
      const aggregatedViews = [this.GROUP_BY_TAB_ELEMENTS.PRODUCT_PARENT.key, this.GROUP_BY_TAB_ELEMENTS.BRAND.key, this.GROUP_BY_TAB_ELEMENTS.SEGMENT.key];
      return aggregatedViews.includes(this.groupBy);
    },
    pageViewsBarColor() {
      return this.currentTabValue === "performance" ? "#8D85E5" : "var(--market-500)";
    }
  },
  methods: {
    generateColorBasedOnState,
    getColorForDecile,
    getColorsBasedOnRange,
    getDescriptionBasedOnKpiKey,
    getCampaignsStateColor,
    getProfitPercentageDecileColor,
    getProductType,
    getCountryFlagFromSalesChannel(sales_channel) {
      const country_code = country_codes_with_flags_and_marketplace_ids.find(e => e.sales_channel.toLowerCase() === sales_channel?.toLowerCase())?.country_code;
      return this.getCountryFlag(country_code);
    },
    handleDatePickerSubmit(date) {
      this.$emit("changeDate", date);
      this.$emit("restoreEvolutionTable");
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleTableState(state) {
      this.$store.dispatch("dashboardV2SetProductTableState", state);
    },
    handleGroupByRefresh() {
      this.$emit("refresh");
    },
    handleClicked() {
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleHeadClick(fieldKey) {
      if (this.loading) return;
      const directionFlip = {
        asc: "desc",
        desc: "asc"
      };
      const direction = directionFlip[this.sort[fieldKey]] ?? "desc";
      this.validateAndHandleSort({
        sort: fieldKey,
        direction
      });
    },
    handleEvolutionSortDirectionChange(direction) {
      if (!direction) return;
      const prefix = this.evolCategory[this.periodCategory] ?? "";
      const suffix = this.evolutionTypeKpi[this.evolutionType] ?? "";
      const sortField = `${prefix}revenue_excl_VAT_evol${suffix}`;
      this.validateAndHandleSort({
        sort: sortField,
        direction
      });
    },
    async sellersClickToFilter(item) {
      // Set the `seller` filter
      this.sellers_filter.selectOnly({
        id: item.seller_id
      }, "id");

      // Set the current group by to `marketplace`
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_SELLERS_SUB_FILTERS, false);
      this.$emit("refreshOtherKpis");
    },
    async sellersClickToClearFilter() {
      // Set the `seller` filter
      this.sellers_filter.clear();
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_SELLERS_SUB_FILTERS, false);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToFilter(item) {
      this.marketplaces_filter.selectOnly({
        sales_channel: item.sales_channel
      }, "sales_channel");

      // Set the current group by to `product`
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToClearFilter() {
      // Set the `marketplace` filter
      this.marketplaces_filter.clear();
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async productChildAsinClickToFilter(item) {
      if (this.getProductType(item) === PRODUCT_TYPES.CHILD || this.getProductType(item) === PRODUCT_TYPES.SOLO) {
        const keyword = item.asin ? [item.asin] : item.asin_list;
        await this.productsSearchAndSelect(keyword);
      }
    },
    async productChildAsinClickToClear() {
      await this.productsReset();
    },
    async productsClickToFilter(item) {
      const asin_list = item.asin ? [item.asin] : [];
      const sku_list = item.sku ? [item.sku] : [];
      await this.productsSearchAndSelect(asin_list, sku_list);
    },
    async productsClickToClearFilter() {
      await this.productsReset();
    },
    async asinsClickToFilter(item) {
      await this.productsSearchAndSelect(item.asin ? [item.asin] : []);
    },
    async asinsClickToClearFilter() {
      await this.productsReset();
    },
    async segmentClickToFilter(item) {
      this.segments.selectOnly({
        segment: item.product_segment
      }, "segment", {
        case_sensitive: true
      });
      this.segments.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_PRODUCTS_SUB_FILTERS);
      this.$emit("refreshOtherKpis");
    },
    async segmentClickToClear() {
      this.segments.clear();
      this.segments.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_PRODUCTS_SUB_FILTERS);
      this.$emit("refreshOtherKpis");
    },
    async productsSearchAndSelect(asin_list = [], sku_list = []) {
      this.products.clear();
      this.products.apply();
      //console.log('keyword', keyword)
      let res = await this.products.asyncSearchAndSelect({
        args: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues,
          asin_list,
          sku_list
        },
        key: "asin"
      });
      if (!res) {
        return;
      }
      this.products.apply();
      this.$emit("refreshOtherKpis");
    },
    async productsReset() {
      await this.products.clearAfterAsyncSearch({
        args: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues
        }
      });
      await this.$emit("refreshOtherKpis");
    },
    async handleBreakdownReset() {
      const clickToClearFilter = this.CLICK_TO_CLEAR_FILTER_OPTIONS[this.groupBy];
      await clickToClearFilter();
    },
    async handleBreakdownSelect(item) {
      const clickToFilter = this.CLICK_TO_FILTER_OPTIONS[this.groupBy];
      await clickToFilter(item);
    },
    async handleRowClick(item, _, event) {
      //console.log('handleRowClick', event)
      const performanceFloatingCompoundTable = this.$refs.performanceFloatingCompoundTable;
      if (performanceFloatingCompoundTable) {
        performanceFloatingCompoundTable.handleNormalize();
      }
      const toggleOption = this.PARENT_TOGGLE_TYPES[this.groupBy];
      if (item.is_parent) {
        toggleOption(item);
      } else {
        this.handleBreakdownRowClicked(item, this.handleBreakdownReset, this.handleBreakdownSelect, this.filteredItems);
      }
    },
    async downloadDashboardV2CSV() {
      const csv_headers = this.csvSources[this.currentTabValue][this.groupBy];
      const csvFileName = this.csvFileName;
      const download = async page => await this.downloader(page, ANALYTICS_CSV_PAGE_SIZE, csv_headers, this.groupByFetcher);
      const str = await this.generateCsvStringWithPagination(csv_headers, Math.ceil(this.totalPages / ANALYTICS_CSV_PAGE_SIZE), download, "-");
      await this.downloadCsv(str, csvFileName);
      this.trackDashboardCsvExport();
    },
    async copyDashboardV2CSV() {
      const csv_headers = this.csvSources[this.currentTabValue][this.groupBy];
      const download = async page => await this.downloader(page, ANALYTICS_CSV_PAGE_SIZE, csv_headers, this.groupByFetcher);
      const str = await this.generateCsvStringWithPagination(csv_headers, Math.ceil(this.totalPages / ANALYTICS_CSV_PAGE_SIZE), download, "-");
      await this.copyCSV(str);
    },
    collapseAllParents() {
      this.standardized_parents = {};
    },
    async handleParentAsinToggle(item) {
      if (this.standardized_parents?.[item.standardized_parent_asin]) {
        this.standardized_parents[item.standardized_parent_asin] = false;
        await this.productsClickToClearFilter();
      } else {
        this.collapseAllParents();
        this.standardized_parents[item.standardized_parent_asin] = true;
        await this.productsSearchAndSelect(item.asin_list);
      }
    },
    async handleProductSegmentToggle(item) {
      if (this.product_segment_parents.get(item?.product_segment).collapsed) {
        this.$store.dispatch("dashboardV2ToggleProductSegmentState", item?.product_segment);
        await this.segmentClickToClear();
      } else {
        this.$store.dispatch("dashboardV2ToggleProductSegmentState", item?.product_segment);
        await this.segmentClickToFilter(item);
      }
    },
    async handleBrandToggle(item) {
      if (this.product_brand_parents.get(item?.brand).collapsed) {
        this.$store.dispatch("dashboardV2ToggleProductBrandState", item?.brand);
        // Set the `seller` filter
        this.brands_filter.clear();
        this.brands_filter.apply();
        await this.$emit("refreshOtherKpis");
      } else {
        this.$store.dispatch("dashboardV2ToggleProductBrandState", item?.brand);
        this.brands_filter.selectOnly({
          brand: item.brand
        }, "brand");
        this.brands_filter.apply();
        await this.$emit("refreshOtherKpis");
      }
    },
    async downloadPerformanceGoogleSheet() {
      const csv_headers = this.csvSources[this.currentTabValue][this.groupBy];
      const download = async page => await this.downloader(page, ANALYTICS_CSV_PAGE_SIZE, csv_headers, this.groupByFetcher);
      const data = await transformGoogleSheetFromAsyncCSV(csv_headers, Math.ceil(this.totalPages / ANALYTICS_CSV_PAGE_SIZE), download);
      const task = await this.downloadCSVWithGoogleSheets("/dashboard/v2/generate/googlesheet", {
        sheet_name: this.csvFileName,
        task_type: "google_sheet_generation",
        data
      });

      //console.log('dashboard task', task);

      if (!task) {
        return;
      }
      this.sheetGenerationTaskIdentifiers[this.groupBy] = task.task_id;
      this.executeTaskStatusHandler(task);
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifiers[this.groupBy]);
    },
    handleRunning() {
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifiers[this.groupBy]);
    },
    handleFailed(data) {
      this.exportLoading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Google sheet generation Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
      throw new Error("Google sheet generation Task failed");
    },
    async handleFinished(data) {
      //console.log('dashboard finished', data);
      if (data) {
        const {
          task_result: {
            share_link
          }
        } = data;
        if (this.asyncUpdateInterval) {
          clearTimeout(this.asyncUpdateInterval);
          this.asyncUpdateInterval = null;
        }
        window.$bus.trigger("showSuccess", {
          visible: true,
          message: "The google sheet has been successfully generated. A link has been sent to your email.",
          delay: 60 // Show alert less than 60 secs
        });
        this.exportLoading = false;
        if (share_link) window.open(share_link, "_blank");
      }
    },
    handleProductValueClick(e) {
      //console.log('handleProductValueClick', e)
    },
    switchEvolutionType($event) {
      const currentType = this.evolutionType === "percentage" ? "currency" : "percentage";
      this.toggleEvolutionType($event, currentType);
    }
  }
};